import React, { useState } from "react";
import { useParams, Link } from "react-router-dom";
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import projects from "./ProjectDetails";

export default function PortfolioDetails() {
  const { id } = useParams();

  const portfolioItem = projects.find(
    (item) => item.id === Number(id)
  );

  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);

  if (!portfolioItem) {
    return (
      <section className="PortfolioDetails">
        <div className="container">
          <div className="text-center py-5">
            <h2>Portfolio Item Not Found</h2>

            <Link to="/portfolio" className="btn btn-primary2 mt-3">
              Back to Portfolio
            </Link>
          </div>
        </div>
      </section>
    );
  }

  const hasMultipleImages = portfolioItem.imgSrc.length > 1;

  return (
    <section className="PortfolioDetails">
      <div className="container">
        <div className="row justify-content-center">

          {/* PROJECT CONTENT */}
          <div className="col-md-10 mb-4">
            <div className="portfolio-details-content text-center">

              {portfolioItem.featured && (
                <span className="portfolio-featured-badge">
                  Featured Project
                </span>
              )}

              <h1>{portfolioItem.heading}</h1>

              <h4 className="brandText">
                {portfolioItem.subHeading}
              </h4>

              <p>{portfolioItem.paragraph}</p>

            </div>
          </div>

          {/* MAIN SLIDER */}
          <div className="col-md-10">
            <div className="portfolio-main-slider">
              <Slider
                asNavFor={nav2}
                ref={(slider) => setNav1(slider)}
                slidesToShow={1}
                slidesToScroll={1}
                swipeToSlide={true}
                autoplay={hasMultipleImages}
                autoplaySpeed={3000}
                infinite={hasMultipleImages}
                arrows={false}
              >
                {portfolioItem.imgSrc.map((img, index) => (
                  <div key={index} className="main-slider-item">
                    <img
                      src={img.src}
                      alt={`${portfolioItem.heading} screenshot ${index + 1}`}
                      className="img-fluid"
                    />
                  </div>
                ))}
              </Slider>
            </div>
          </div>

          {/* THUMBNAIL SLIDER */}
          {hasMultipleImages && (
            <div className="col-md-9 mt-3">
              <div className="portfolio-thumbnail-slider">
                <Slider
                  asNavFor={nav1}
                  ref={(slider) => setNav2(slider)}
                  slidesToShow={3}
                  slidesToScroll={1}
                  swipeToSlide={true}
                  focusOnSelect={true}
                  centerMode={true}
                  infinite={portfolioItem.imgSrc.length > 3}
                  arrows={false}
                  responsive={[
                    {
                      breakpoint: 768,
                      settings: {
                        slidesToShow: 2,
                        centerMode: false,
                      },
                    },
                    {
                      breakpoint: 576,
                      settings: {
                        slidesToShow: 1,
                        centerMode: false,
                      },
                    },
                  ]}
                >
                  {portfolioItem.imgSrc.map((img, index) => (
                    <div key={index} className="thumbnail-slider-item">
                      <img
                        src={img.src}
                        alt={`${portfolioItem.heading} thumbnail ${index + 1}`}
                        className="img-fluid"
                      />
                    </div>
                  ))}
                </Slider>
              </div>
            </div>
          )}

          {/* BUTTONS */}
          <div className="col-12 text-center mt-4">

            {portfolioItem.webSrc && (
              <a
                href={portfolioItem.webSrc}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-primary2 me-3"
              >
                {portfolioItem.webLink}
                <i className="fa fa-external-link ms-2"></i>
              </a>
            )}

            <Link
              to="/portfolio-list"
              className="btn btn-outline-secondary"
            >
              Back to Portfolio
            </Link>

          </div>

        </div>
      </div>
    </section>
  );
}